import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Accordion, Card } from 'src/@vymo/ui/blocks';
import { Keys, locale } from 'src/i18n';
import DocumentRecord from './documentRecord';
import LoanHeader from './loanHeader';
import { PDDContentProps } from './types';
import styles from './index.module.scss';

function PDDContent({
  error,
  loans,
  filteredLoans,
  isLoading,
  expandedLoanNo,
  onLoanClick,
}: PDDContentProps) {
  if (error) {
    return (
      <Card classNames={styles.myPDD__messageCard}>
        <Text classNames={styles.myPDD__error}>{error}</Text>
      </Card>
    );
  }

  if (loans.length === 0 && !isLoading) {
    return (
      <Card classNames={styles.myPDD__messageCard}>
        <Text>{locale(Keys.ABC_PDD_NO_RECORDS_FOUND)}</Text>
      </Card>
    );
  }

  if (filteredLoans.length === 0 && !isLoading) {
    return (
      <Card classNames={styles.myPDD__messageCard}>
        <Text>{locale(Keys.ABC_PDD_NO_MATCHING_RECORDS)}</Text>
      </Card>
    );
  }

  return (
    <div className={styles.myPDD__list}>
      {filteredLoans.map((loan) => (
        <Accordion
          key={loan.loanNo}
          title={<LoanHeader loan={loan} />}
          open={expandedLoanNo === loan.loanNo}
          onClick={(isOpen) => onLoanClick(loan.loanNo, isOpen)}
          border={false}
          className={styles.myPDD__accordion}
        >
          <div className={styles.myPDD__body}>
            {loan.records.map((record) => (
              <DocumentRecord key={record.id} record={record} />
            ))}
          </div>
        </Accordion>
      ))}
    </div>
  );
}

export default PDDContent;
